const getTextWidth = function (txt){
  const ipaexg = "IPAexゴシック"
  return new Promise((resolve,reject) => {
      const myFont = new FontFace(ipaexg, 'url(/documents/fonts/ipaexg.ttf)')
      myFont.load().then(font => {
        document.fonts.add(font)
      }).then(() => {
        var canvas = canvas || (canvas = document.createElement("canvas"));
        const ctx = canvas.getContext('2d')
      
        ctx.font = '10.5px ' + ipaexg
        resolve(ctx.measureText(txt).width)
      })
  })
}

const getTextSize = async function (text){
  var textMaxWidth = 0
  var textMaxHeight = 0
  // 文字列を改行で分割
  var splitedText = text != null?text.split('\n'):[];
  // 半角・全角それぞれでテキスト幅を加算していく
  var textRowWidthList = [];
  for (var index in splitedText) {
      await getTextWidth(splitedText[index]).then( value => {
          textRowWidthList.push(value);
      })
  }
  const aryMax = function (a, b) {return Math.max(a, b);}
  var maxRowWidth = textRowWidthList.reduce(aryMax, 0);
  // 最大のテキスト幅に合わせて、テキストエリアの幅を変える
  var newWidth = maxRowWidth + 25;
  if (newWidth < 200) {
      textMaxWidth = 200;
  } else {
      textMaxWidth = newWidth;
  }
  // 行数に合わせて、テキストエリアの高さを変える
  var newHeight = splitedText.length * 11.5 + 18;
  if (newHeight < 29.5) {
      textMaxHeight = 29.5;
  } else {
      textMaxHeight = newHeight;
  }
  
  return new Promise((resolve,reject) => {
    resolve({"textMaxWidth":textMaxWidth,"textMaxHeight":textMaxHeight})
  })
}

const hankaku2Zenkaku = function (str) {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
}

// 定義
export { getTextWidth, getTextSize, hankaku2Zenkaku }